import { noop } from '@kofno/piper';
import { observer } from 'mobx-react';
import { useRef } from 'react';
import ClickOutsideStore from '../../../../../../ClickOutsideStore';
import { useOpenable } from '../../../../../Modal/UseOpenable';
import LearningCollectionEditStore from '../../../Edit/Store';
import { AddingLearningDesign, Building, EditFormSubmissionError } from '../../../Edit/Store/Types';
import NewSectionButton from './NewSectionButton';
import NewSectionPopup from './NewSectionPopup';

interface Props {
  store: LearningCollectionEditStore;
  state: Building | EditFormSubmissionError | AddingLearningDesign;
}

function NewSectionLink({ store, state }: Props) {
  const { open: openModal, close, modalState } = useOpenable();
  const tooltipRef = useRef<HTMLDivElement>(null);
  const open = () => {
    ClickOutsideStore.addListener({ ref: tooltipRef, callback: close });
    openModal();
  };

  switch (modalState.kind) {
    case 'open':
      return (
        <div ref={tooltipRef}>
          <NewSectionButton action={noop} state={state} />
          <NewSectionPopup store={store} close={close} />
        </div>
      );

    case 'closed':
      return <NewSectionButton action={open} state={state} />;
  }
}

export default observer(NewSectionLink);
